module.exports = __webpack_public_path__ + "static/media/SAFE_v3.4.3.81b31b90.apk";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SAFE_v3.4.3.apk
// module id = 528
// module chunks = 0